"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LAWYER_QUESTION_GROUPS = void 0;
/* eslint-disable sonarjs/no-duplicate-string */
const Questions = require("../../questions/questions");
const answer_1 = require("../../utils/answer");
const group_1 = require("../../utils/group");
const { Question } = Questions;
exports.LAWYER_QUESTION_GROUPS = [
    (0, group_1.group)({
        uniqueKey: "LAWYER_GETTING_STARTED_PERSONAL_INFO",
        title: "Your Personal Information",
        subtitle: "What is your full name? This information will be displayed in app and your first name will be shared with clients assigned to your account.",
        id: 86,
        content: [
            Question["First name(s)"].label("PD_1"),
            Question["Last name"].label("PD_2"),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "LAWYER_INTAKE_REPRESENTATIVE_NAME",
        title: "Appointment of Representative Personal Information",
        subtitle: "Please provide us with the name of the representative from your legal team. This information with be entered into the generated PDFs for each application for your customers (i.e. IMM 5476 E, EMP 5624, etc)",
        id: 87,
        content: [
            Question["First name(s)"].label("LAW_1"),
            Question["Last name"].label("LAW_2"),
            Question["Job Title"].label("LAW_3"),
            Question["Email address"].label("LAW_4"),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "LAWYER_INTAKE_REPRESENTATIVE_LEGAL",
        title: "Appointment of Representative Business Information",
        subtitle: "Please provide us with the business details of your legal firm. This information with be entered into the generated PDFs for each application for your customers (i.e. IMM 5476 E, EMP 5624, etc)",
        id: 88,
        content: [
            Question["Legal Business Name"].label("LAW_5"),
            Question["Is your business operating name different from your business legal name?"]
                .label("LAW_17")
                .ifAnswerEquals(answer_1.answer.yes)
                .renderTheseQuestions([
                Question["Business operating name"].label("LAW_18"),
            ]),
            Question["Business Phone Number"].label("LAW_13"),
            Question["15-digit CRA Payroll Number"].label("LAW_16"),
            Question["Please select the organization that applies to you"]
                .label("LAW_19")
                .ifAnswerEquals("Immigration Consultant")
                .renderTheseQuestions([Question["ICCRC Membership ID"].label("LAW_20")])
                .ifAnswerEquals("Immigration Lawyer")
                .renderTheseQuestions([
                Question["Law Society Province"].label("LAW_14"),
                Question["Law Society Membership ID #"].label("LAW_15"),
            ])
                .ifAnswerEquals("Quebec Notary")
                .renderTheseQuestions([
                Question["Chambre of Notaries of Quebec Membership ID"].label("LAW_21"),
            ])
                .ifAnswerEquals("Other")
                .renderTheseQuestions([
                Question["Other Third-Party Representative"].label("LAW_22"),
            ]),
        ],
    }),
    (0, group_1.group)({
        uniqueKey: "LAWYER_INTAKE_REPRESENTATIVE_ADDRESS",
        title: "Appointment of Representative Business Address",
        subtitle: "Please provide us with the business address of your legal firm. This information with be entered into the generated PDFs for each application for your customers (i.e. IMM 5476 E, EMP 5624, etc)",
        id: 89,
        content: [
            Question["Street number"].label("LAW_6"),
            Question["Street name"].label("LAW_7"),
            Question["Apt or Unit number"].label("LAW_8"),
            Question["City or Town"].label("LAW_9"),
            Question["Province"].label("LAW_10"),
            Question["Country or Territory"].label("LAW_11"),
            Question["Postal Code"].label("LAW_12"),
        ],
    }),
];
